module.exports = __webpack_public_path__ + "img/blog.759e3279.webp";